import { Box } from "@chakra-ui/react";
import { NodeProps } from "@xyflow/react";
import { GrayScaleContext } from "features/entities/EntityCreatePage/EntityGraph/GrayScaleContext";
import InvestingHandles from "features/entities/EntityCreatePage/EntityGraph/nodes/InvestingHandles";
import { NodeLabel } from "features/entities/EntityCreatePage/EntityGraph/nodes/NodeLabel";
import { type ParallelogramNode as NodeType } from "features/entities/EntityCreatePage/EntityGraph/nodes/types";
import { useContext } from "react";

// TODO ENG-8460 something very weird is going on here but on initial mount the handles are not working correctly
// if you flip between entity types it works fine
export const ParallelogramNode = ({ data, id }: NodeProps<NodeType>) => {
  const { isGrayScale } = useContext(GrayScaleContext);
  return (
    <Box
      style={{
        position: "relative",
        width: "200px",
        height: "100px",
        color: isGrayScale ? "black" : "white",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          backgroundColor: isGrayScale ? "white" : data.backgroundColor,
          width: "200px",
          height: "100px",
          transform: "skewX(-20deg)",
          border: isGrayScale ? "2px solid black" : "none",
          zIndex: -1,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "200px",
          height: "100px",
          zIndex: 1,
        }}
        textAlign="center"
      >
        <NodeLabel label={data.label} />
      </Box>
      <InvestingHandles nodeId={id} />
    </Box>
  );
};
